import { render, staticRenderFns } from "./counterparties.vue?vue&type=template&id=15c3325a&scoped=true&"
import script from "./counterparties.vue?vue&type=script&lang=js&"
export * from "./counterparties.vue?vue&type=script&lang=js&"
import style0 from "./counterparties.vue?vue&type=style&index=0&id=15c3325a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c3325a",
  null
  
)

export default component.exports